import type { IntlService } from 'ember-intl';

type TParamters = Parameters<IntlService['t']>;

interface Options {
  silent?: boolean | string;
  append?: string | number;
  intlOptions?: TParamters[1];
}

interface WithIntl {
  intl: IntlService;
}

export function lookupTranslation(
  this: WithIntl,
  lookups: string[],
  options: Options = {},
) {
  // Append
  if (options.append || options.append === 0) {
    lookups = lookups.map((path) => `${path}.${options.append}`);
  }

  const path = lookups.find((path) => this.intl.exists(path));

  // Silently fail
  if (options.silent && !path) {
    return;
  }

  // Use the first path for the error message
  return this.intl.t(path ?? lookups[0]!, options.intlOptions);
}

export function translate(
  this: WithIntl,
  value: string | boolean,
  lookups: string[],
  options: Options,
) {
  if (value === false) {
    return;
  }

  if (value) {
    return value;
  }

  return lookupTranslation.call(this, lookups, options);
}

export function labelValueOptions(
  this: WithIntl,
  values: (string | number)[],
  lookups: string[],
) {
  return values.map((value) => {
    const label = lookupTranslation.call(this, lookups, { append: value });

    return { value, label };
  });
}
